export default __webpack_public_path__ + "static/media/merge.519acd77.svg";